export default "__VITE_ASSET__DfcHhvwl__"